import { JackpotLevel, JackpotValue2 } from "./api";
import { Orientation } from "./FitScreen";
import { ISkeletonData } from "pixi-spine";
// import { JackpotLevel, JackpotValue2 } from "./api";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { Resourceful, Resourceful2 } from "./ResourceManager/Resourceful";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import * as PIXI from 'pixi.js'

// export interface IJackpotDisplay extends Resourceful
// {
// 	StartAnimations(): void;
// 	StopAnimations(): void;
// 	View(): HTMLElement;
// 	Update(): void;
// 	UpdateValues(jackpotValues: JackpotValue2[]): void;
// 	TitleHide();
// 	TitleShow();	
// 	Pause();
// 	Resume();
// 	Reset(jpLevel? : JackpotLevel);

// }

//missing convert for abstract class 
export abstract class IJackpotDisplay implements Resourceful2{

	// protected jp1text: JackpotText = null;
	// protected jp2text: JackpotText = null;
	// protected jp3text: JackpotText = null;
	// protected jp4text: JackpotText = null;

	protected jackpotTextMapping: Record<JackpotLevel, JackpotText> = {} as Record<JackpotLevel, JackpotText>;
	public JackpotLevels(): JackpotLevel[]
	{
		const levels = Object.keys(this.jackpotTextMapping);
		return levels as JackpotLevel[];
	}
	public constructor(params: JackpotDisplayParams) {}


	public async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
	}

	public async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {
	}

	public Reset(jpLevel: JackpotLevel[]) {
		console.log("Reset JackpotLevel:", jpLevel);
		this.jpValuesSaved.forEach((jp) => {
		let jpCurrentForReset =	jpLevel.find((jpReset)=>[
				jpReset == jp.JackpotLevel
			])
		
			if (jpCurrentForReset) {
				console.log("Reset JackpotLevel:", jp.JackpotLevel, "ResetValue:", jp.ResetValue);
				jp.CurrentValue = jp.ResetValue;
				console.log("Current JackpotLevel After Reset:", jp.CurrentValue);
			}
		});

		console.log("JackpotUpdated",this.jpValuesSaved);

		this.InternalUpdate(this.jpValuesSaved);
	}

	public Resume() {		
		this.pauseJackpotValues = false;
		// this.jpValuesSaved.forEach((jp) => {
		// 	console.log("Resume JackpotLevel:", jp.JackpotLevel, "CurrentValue:", jp.CurrentValue);
		// });
		this.UpdateValues(this.jpValuesSaved);
	}

	protected pauseJackpotValues = false;
	public Pause() {
		//console.log("Pause JackpotValues");
		this.pauseJackpotValues = true;
	}

	public InternalUpdate(jackpotValues: JackpotValue2[]): void {

		for (let val of jackpotValues)
		{
			let jpText = this.jackpotTextMapping[val.JackpotLevel];
			if (jpText == null)
			{
				// no such text?
				continue;
			}

			jpText.SetTarget(val.CurrentMultipliedValue);
		}

		// //console.log("Jackpot RedraUpdateJackpotValues:",jackpotValues);
		// let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp1);
		// if (jp1 != null) {
		// 	this.jackpotTextMapping[JackpotLevel.Jp1]?.SetTarget(jp1.CurrentMultipliedValue);
		// }

		// let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp2);
		// if (jp2 != null) {
		// 	this.jackpotTextMapping[JackpotLevel.Jp2]?.SetTarget(jp2.CurrentMultipliedValue);
		// }

		// let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp3);
		// if (jp3 != null) {
		// 	this.jackpotTextMapping[JackpotLevel.Jp3]?.SetTarget(jp3.CurrentMultipliedValue);
		// }

		// let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp4);
		// if (jp4 != null) {
		// 	this.jackpotTextMapping[JackpotLevel.Jp4]?.SetTarget(jp4.CurrentMultipliedValue);
		// }			
	}

	protected jpValuesSaved: JackpotValue2[] = [];
	public UpdateValues(jackpotValues: JackpotValue2[]): void {
		this.jpValuesSaved = jackpotValues;
		if (this.pauseJackpotValues) {
			//console.log("IsJackpot");
			return
		}
		//inter		
		this.InternalUpdate(this.jpValuesSaved);
	}

	public abstract TitleHide();
	public abstract TitleShow();

	public abstract	StartAnimations(): void;
	public abstract StopAnimations(): void;
 	public abstract View(): HTMLElement;
	public abstract Update(): void;

	public OnResize(x: number, y: number, orientation: Orientation): void {
	}
	public GetSImgTitleJackpotSpine() : HTMLImageElement{
		return null
	}

	public GetSpineSkeleton() : ISkeletonData{
		return null
	}
}

export abstract class IPixiJackpotDisplay extends IJackpotDisplay
{
	public constructor(params: JackpotDisplayParams)
	{
		super(params);
	}

	public abstract get ViewPixiApp(): PIXI.Application<HTMLCanvasElement>;
}
declare global{
	var jackpotDisplayGlobal : IJackpotDisplay
}
